import logo from "../../assets/spizop-logo.png";
import maleProfilePic from "../../assets/profile_pic_male.jpeg";
import closeIcon from "../../assets/close_icon.png";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios"; // Import axios for API calls
import "./products.scss"; // Create and import a CSS file for styling
import { toast } from "react-toastify";
import parse from "html-react-parser";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

interface Products {
  _id: string;
  productName: string;
  productDescription: string;
  mrpPrice: number;
  category: string;
  productImage: string;
  productWeightInGram: number;
  selPrice: number;
  taxInPercentage: number;
}

const Products = () => {
  const [userDetails, setUserDetails] = useState<any>(null);
  const [products, setProductss] = useState<Products[]>([]);
  const [role, setRole] = useState<string>("");
  const [showOverlay, setShowOverlay] = useState<boolean>(false);
  const [deleteModalVisible, setDeleteModalVisible] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true); // Add loading state
  const [imageFile, setImageFile] = useState<File | null>(null); // For image upload
  const [productsToDelete, setProductsToDelete] = useState<Products | null>(
    null
  );
  const [addModalVisible, setAddModalVisible] = useState<boolean>(false); // Add Products Modal
  const [newProducts, setNewProducts] = useState({
    productName: "",
    productDescription: "",
    mrpPrice: "",
    selPrice: "",
    category: "",
    productWeightInGram: "",
    taxInPercentage: "",
  }); // New Products state
  const navigate = useNavigate();
  const isInitialRender = useRef(true);

  const [isExpanded, setIsExpanded] = useState(false);
  const toggleReadMore = () => {
    setIsExpanded((prev) => !prev);
  };

  // Fetch user details and products
  const fetchUserDetails = async () => {
    try {
      const email = localStorage.getItem("email");
      const token = localStorage.getItem("token");
      if (!email || !token) {
        alert("Authentication failed! Redirecting to login.");
        navigate("/login");
        return;
      }

      const config = { headers: { Authorization: `Bearer ${token}` } };
      const response = await axios.get(
        `https://spizopapi.fitoja.in/api/get-employee-details/${email}`,
        config
      );
      setUserDetails(response.data);
      setRole(response.data.role);
      fetchAllProductss();
    } catch (error) {
      console.error("Failed to fetch user details:", error);
      handleLogout();
    }
  };

  const fetchAllProductss = async () => {
    try {
      const response = await axios.get(
        `https://spizopapi.fitoja.in/api/get-store-info`
      );
      setProductss(response.data.data);
    } catch (error) {
      console.error("Failed to fetch products:", error);
    } finally {
      setLoading(false); // Stop the loading indicator once API responds
    }
  };

  //Create new A\Product
  const handleAddProducts = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!newProducts?.productName || !newProducts.category || !imageFile) {
      toast.error("Please fill in all the required fields!");
      return;
    }

    const token = localStorage.getItem("token");
    const formData = new FormData();

    // 1. Append text fields FIRST
    formData.append("productName", newProducts.productName);
    formData.append("category", newProducts.category);
    formData.append("productDescription", newProducts.productDescription);
    formData.append("mrpPrice", newProducts.mrpPrice);
    formData.append("selPrice", newProducts.selPrice);
    formData.append("taxInPercentage", newProducts.taxInPercentage);
    formData.append("productWeightInGram", newProducts.productWeightInGram);

    // 2. Append the file LAST
    formData.append("productImage", imageFile);

    try {
      const response = await axios.post(
        "https://spizopapi.fitoja.in/api/create-product",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            // Include Authorization if your API requires it for creating products
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        toast.success("Product created successfully!");
        closeAddModal();
        fetchAllProductss();
      } else {
        toast.error(response.data.msg || "Failed to create product.");
      }
    } catch (error: any) {
      console.error("Upload error:", error.response?.data);
      toast.error(
        error.response?.data?.msg ||
          "Failed to create product. Please try again."
      );
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("email");
    localStorage.removeItem("token");
    navigate("/login");
  };

  const handleDelete = async () => {
    if (!productsToDelete) return;
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        alert("Authentication failed! Redirecting to login.");
        navigate("/login");
        return;
      }

      const config = { headers: { Authorization: `Bearer ${token}` } };
      await axios.delete(
        `https://spizopapi.fitoja.in/api/delete-product-by-id/${productsToDelete._id}`,
        config
      );
      fetchAllProductss();
      closeDeleteModal();
    } catch (error) {
      console.error("Failed to delete employee:", error);
      alert("Failed to delete employee. Please try again.");
    }
  };

  const openDeleteModal = (products: Products) => {
    setProductsToDelete(products);
    setDeleteModalVisible(true);
  };

  const closeDeleteModal = () => {
    setDeleteModalVisible(false);
    setProductsToDelete(null);
  };

  const openAddModal = () => {
    setAddModalVisible(true);
  };

  const closeAddModal = () => {
    setAddModalVisible(false);
    setNewProducts({
      productName: "",
      productDescription: "",
      mrpPrice: "",
      selPrice: "",
      category: "",
      productWeightInGram: "",
      taxInPercentage: "",
    });
  };

  useEffect(() => {
    if (isInitialRender.current) {
      fetchUserDetails();
      isInitialRender.current = false;
    }
  }, []);

  return (
    <div className="products">
      {/* Loading indicator */}
      {loading && (
        <div className="loading-indicator">
          <div className="spinner"></div>
          <p>Loading, please wait...</p>
        </div>
      )}

      {!loading && (
        <>
          {/* Header Section */}
          <header className="dashboard-header">
            <div className="logo" onClick={() => navigate("/dashboard")}>
              <img src={logo} />
            </div>
            <div
              className="profile-section"
              onClick={() => setShowOverlay(!showOverlay)}
            >
              <img className="profile-pic" src={maleProfilePic} alt="Profile" />
            </div>
          </header>

          {/* Overlay for showing user details */}
          {showOverlay && userDetails && (
            <div className="profile-overlay">
              <div className="overlay-content">
                <img
                  className="close_icon"
                  onClick={() => setShowOverlay(false)}
                  src={closeIcon}
                />
                <p>
                  <strong>Name:</strong> {userDetails.name}
                </p>
                <p>
                  <strong>Email:</strong> {userDetails.email}
                </p>
                <p>
                  <strong>Phone Number:</strong> {userDetails.phoneNumber}
                </p>
                <p>
                  <strong>Role:</strong> {userDetails.role}
                </p>
                <p>
                  <strong>Gender:</strong> {userDetails.gender}
                </p>
                <button className="logout-button" onClick={handleLogout}>
                  Logout
                </button>
              </div>
            </div>
          )}

          <h2 style={{ marginTop: "110px", marginBottom: "0px" }}>
            All Products
          </h2>

          <div className="create-new-products" onClick={openAddModal}>
            <span>Add new Product</span>
          </div>

          <hr></hr>

          <div className="products-list">
            {products.length > 0 ? (
              products.map((products) => (
                <div key={products._id} className="products-card">
                  <div className="products-details">
                    <span>
                      <img
                        className="products-details-img"
                        src={products?.productImage}
                      ></img>
                    </span>
                    <div>
                      <p style={{ textAlign: "start" }}>
                        <strong>Product Name:</strong>{" "}
                        <span>{products?.productName}</span>
                      </p>
                      <p style={{ textAlign: "start" }}>
                        <strong>MRP:</strong> <span>{products?.mrpPrice}</span>
                      </p>
                      <p style={{ textAlign: "start" }}>
                        <strong>Selling Price:</strong>{" "}
                        <span>{products?.selPrice}</span>
                      </p>
                      <p style={{ textAlign: "start" }}>
                        <strong>Tax (In %):</strong>{" "}
                        <span>{products?.taxInPercentage}</span>
                      </p>
                      <div style={{ display: "grid" }}>
                        <p
                          style={{
                            textAlign: "start",
                            overflow: isExpanded ? "visible" : "hidden",
                            display: isExpanded ? "block" : "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: isExpanded ? "none" : "4",
                            whiteSpace: "pre-wrap",
                          }}
                        >
                          <strong>Description:</strong>{" "}
                          <span>{parse(products?.productDescription)}</span>
                        </p>
                        {products?.productDescription?.length > 0 && (
                          <button
                            onClick={toggleReadMore}
                            style={{
                              color: "black",
                              background: "darkturquoise",
                              border: "none",
                              borderRadius: "6px",
                              cursor: "pointer",
                              padding: "0px 10px",
                              fontSize: "inherit",
                              width: "fit-content",
                            }}
                          >
                            {isExpanded ? "Read less" : "Read more..."}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* <div
                    className="delete-icon"
                    onClick={() => openDeleteModal(products)}
                  >
                    <img className="img" src={deleteIcon}></img>
                  </div> */}
                </div>
              ))
            ) : (
              <p
                style={{
                  display: "flex",
                  height: "70vh",
                  alignItems: "center",
                }}
              >
                No Product found
              </p>
            )}
          </div>

          {deleteModalVisible && (
            <div className="delete-modal">
              <div className="delete-modal-content">
                <h2>Delete Confirmation</h2>
                <p>Are you sure you want to delete this Product?</p>
                <span style={{ display: "flex", gap: "20px" }}>
                  <button onClick={closeDeleteModal} className="cancel-button">
                    Cancel
                  </button>
                  <button
                    onClick={handleDelete}
                    className="confirm-delete-button"
                  >
                    Yes, Delete
                  </button>
                </span>
              </div>
            </div>
          )}

          {addModalVisible && (
            <div className="add-modal">
              <div className="add-modal-content">
                <h2>Add new Product</h2>
                <form onSubmit={handleAddProducts}>
                  <input
                    type="text"
                    placeholder="Enter Product Name"
                    value={newProducts.productName}
                    onChange={(e) =>
                      setNewProducts({
                        ...newProducts,
                        productName: e.target.value,
                      })
                    }
                    required
                  />
                  <ReactQuill
                    style={{ width: "100%" }}
                    value={newProducts.productDescription}
                    onChange={(value) =>
                      setNewProducts({
                        ...newProducts,
                        productDescription: value,
                      })
                    }
                    modules={{
                      toolbar: [
                        [{ header: [1, 2, 3, 4, 5, 6, false] }],
                        ["bold", "italic", "underline"],
                        [{ list: "ordered" }, { list: "bullet" }],
                        [{ align: [] }],
                        ["image"],
                        ["clean"], // Remove formatting
                      ],
                    }}
                    formats={[
                      "header",
                      "bold",
                      "italic",
                      "underline",
                      "blockquote",
                      "code-block",
                      "list",
                      "bullet",
                      "align",
                      "link",
                      "image",
                    ]}
                  />
                  <input
                    type="text"
                    placeholder="Enter Product Category"
                    value={newProducts.category}
                    onChange={(e) =>
                      setNewProducts({
                        ...newProducts,
                        category: e.target.value,
                      })
                    }
                    required
                  />
                  <input
                    type="number"
                    placeholder="Enter MRP Price (In ₹)"
                    value={newProducts.mrpPrice}
                    onChange={(e) =>
                      setNewProducts({
                        ...newProducts,
                        mrpPrice: e.target.value,
                      })
                    }
                    required
                  />
                  <input
                    type="number"
                    placeholder="Enter Selling Price (In ₹)"
                    value={newProducts.selPrice}
                    onChange={(e) =>
                      setNewProducts({
                        ...newProducts,
                        selPrice: e.target.value,
                      })
                    }
                    required
                  />
                  <input
                    type="number"
                    placeholder="Enter Product Weight (In grams)"
                    value={newProducts.productWeightInGram}
                    onChange={(e) =>
                      setNewProducts({
                        ...newProducts,
                        productWeightInGram: e.target.value,
                      })
                    }
                    required
                  />
                  <input
                    type="number"
                    placeholder="Enter Tax (In %)"
                    value={newProducts.taxInPercentage}
                    onChange={(e) =>
                      setNewProducts({
                        ...newProducts,
                        taxInPercentage: e.target.value,
                      })
                    }
                    required
                  />
                  <div>
                    <input
                      type="file"
                      name="productImage"
                      onChange={(e) =>
                        setImageFile(e.target.files ? e.target.files[0] : null)
                      }
                      required
                    />
                  </div>
                  <button type="submit" className="products-button">
                    Create Product
                  </button>
                  <button
                    type="button"
                    onClick={closeAddModal}
                    className="cancel-button"
                  >
                    Cancel
                  </button>
                </form>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Products;
